module.exports = __webpack_public_path__ + "static/media/fresh-snow.9d7eecbb.png";